import { Component, OnInit } from '@angular/core';
import { UserInteractionsService } from '../../service/user-interactions.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { EMDMICONS } from '../../../../common/constants/icon-packs.constant';
import { searchIcon } from '@progress/kendo-svg-icons';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { pagination } from '../../../../common/constants/initial-config';

export class DataItem {
  category: string;
  count: number;
  value: number;
}
@Component({
  selector: 'app-user-interactions',
  standalone: false,
  templateUrl: './user-interactions.component.html',
  styleUrl: './user-interactions.component.scss'
})
export class UserInteractionsComponent implements OnInit {
  public value: Date = new Date(2025, 2, 10);
  Isvariant: boolean = true;
  displayFlag: boolean = false;
  chartData: any[] = [];
  topUserInteractionsData: any[] = [];
  topUserInteractionsDataProduct: any[] = [];
  topUserInteractionsDataReport: any[] = [];
  toggleButton = 1;
  titleLable: string = '';
  userInteractionsPVOrReportsTableData: GridDataResult = { data: [], total: 0 };
  kendoDate: any;
  frmuserInteractions!: FormGroup;
  isChartShow: boolean = true;
  IsCardActive: string = '';
  isLoading: boolean = true;
  iconPacks = EMDMICONS;
  searchIcon = searchIcon;
  pageSize: any = pagination.csmrtPerPageLimit;
  skip: any = 0;


  constructor(private userInteractionService: UserInteractionsService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {

  }

  ngOnInit() {
    this.getChart();
    this.topUserInteractions();
    this.initiateFrmUserInteractions();

  }
  initiateFrmUserInteractions() {
    this.frmuserInteractions = this.fb.group({
      SearchTerm: ['', [Validators.required]],
      AccessedAt: [''],
    });
  }
  onSubmit() {
    this.isChartShow = false;
    const formData: any = new FormData();
    this.skip = 0;
    if (this.frmuserInteractions.value.SearchTerm != '' && this.frmuserInteractions.value.SearchTerm != null)
      formData.append('SearchTerm', this.frmuserInteractions.value.SearchTerm);
    else
      formData.append('SearchTerm', this.titleLable);
    const formattedDate: any = (this.frmuserInteractions.value.AccessedAt != '' && this.frmuserInteractions.value.AccessedAt != undefined) ? this.datePipe.transform(this.frmuserInteractions.value.AccessedAt, 'yyyy-MM-dd') : '';
    formData.append('AccessedAt', formattedDate);
    formData.append('pageStartIndex', this.skip);
    formData.append('PageSize', this.pageSize);
    this.getUserInteractionsPVOrReportsTableData(formData)
  }
  resetForm() {
    this.frmuserInteractions.reset();
    this.isChartShow = true;
    this.getChart();
  }

  pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;

    const formData = new FormData();
    //formData.append('SearchTerm', this.titleLable);
    if (this.frmuserInteractions.value.SearchTerm != '' && this.frmuserInteractions.value.SearchTerm != null)
      formData.append('SearchTerm', this.frmuserInteractions.value.SearchTerm);
    else
      formData.append('SearchTerm', this.titleLable);
    const formattedDate: any = (this.frmuserInteractions.value.AccessedAt != '' && this.frmuserInteractions.value.AccessedAt != undefined) ? this.datePipe.transform(this.frmuserInteractions.value.AccessedAt, 'yyyy-MM-dd') : '';
    formData.append('AccessedAt', formattedDate);

    formData.append('pageStartIndex', this.skip);
    formData.append('PageSize', this.pageSize);
    this.getUserInteractionsPVOrReportsTableData(formData);

  }
  getChart() {
    this.isChartShow = true;
    this.userInteractionService.getChart({}, this.Isvariant).subscribe({
      next: (response: any) => {
        this.chartData = response;
        // this.chartData.map(element => {
        //   element.value='aaa'+123+'jjjj';
        //   return element
        // });
      },
      error: (err: any) => {
        console.error(err);
      }
    })
  }

  topUserInteractions() {
    this.userInteractionService.gettopUserInteractions({}, true).subscribe({
      next: (response: any) => {
        this.topUserInteractionsData = response;
        this.topUserInteractionsDataProduct = response;
      },
      error: (err: any) => {
        console.error(err);
      }
    })
    this.userInteractionService.gettopUserInteractions({}, false).subscribe({
      next: (response: any) => {
        this.topUserInteractionsDataReport = response;
      },
      error: (err: any) => {
        console.error(err);
      }
    })
  }
  getUserInteractionsPVOrReportsTableData(formData: any) {
    this.isLoading = true;
    this.isChartShow = false;
    this.userInteractionService.getUserInteractionsPVOrReportsTableData(formData, this.Isvariant).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.userInteractionsPVOrReportsTableData.data = response;
        if (response.length > 0) {
          this.userInteractionsPVOrReportsTableData.total = response[0].totalRowCount;;
        }

      },
      error: (err: any) => {
        console.error(err);
      }
    })
  }
  viewProduct() {
    this.titleLable = '';
    this.Isvariant = !this.Isvariant;
    this.topUserInteractionsData = [];
    this.getChart();
    //this.topUserInteractions();
    if (this.Isvariant)
      this.topUserInteractionsData = this.topUserInteractionsDataProduct;
    else
      this.topUserInteractionsData = this.topUserInteractionsDataReport;

  }

  showMore(label: string) {
    this.isChartShow = false;
    this.titleLable = label;
    this.frmuserInteractions.reset();
    this.IsCardActive = label;
    this.skip = 0;
    const formData = new FormData();
    formData.append('SearchTerm', this.titleLable);
    formData.append('AccessedAt', '');
    formData.append('pageStartIndex', this.skip);
    formData.append('PageSize', this.pageSize);
    this.getUserInteractionsPVOrReportsTableData(formData);
  }

  onSeriesClick(e: any): void {
    this.IsCardActive = e.dataItem.label;
    this.titleLable = e.dataItem.label;
    this.skip = 0;
    const formData = new FormData();
    formData.append('SearchTerm', e.dataItem.label);
    formData.append('AccessedAt', '');
    formData.append('pageStartIndex', this.skip);
    formData.append('PageSize', this.pageSize);
    this.getUserInteractionsPVOrReportsTableData(formData);
  }

  isToday(tmpDate: Date): boolean {
    const today = new Date();
    const date = new Date(tmpDate);
    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  }


}
